<script lang="ts">
  import type { GetDetailAggregationResult } from '../../repositories/hatneohama/types';
  import { loginUser } from '../../components/auth/LoginUser';
  import { onDestroy } from 'svelte';

  export let detailAggregations!: GetDetailAggregationResult[];
  let pageStatus: 'TOP' | 'DETAIL' = 'TOP';
  let detailTitle: '適格請求書' | '適格返還請求書' = '適格請求書';
  let selectedDetail: GetDetailAggregationResult;

  function displayDateYm(date: string) {
    return `${date.slice(0, 4)}年${date.slice(4, 6)}月`;
  }

  function displayDateYmd(date: string) {
    return `${date.slice(0, 4)}/${date.slice(4, 6)}/01`;
  }

  function handleShowDetail(detailInfo: GetDetailAggregationResult) {
    selectedDetail = detailInfo;
    detailTitle = selectedDetail.amount > 0 ? '適格請求書' : '適格返還請求書';
    pageStatus = 'DETAIL';
  }

  function handleShowTop() {
    pageStatus = 'TOP';
  }

  onDestroy(() => {
    location.reload();
  });
</script>

{#if pageStatus === 'TOP'}
  <div class="mb-5 screen-title">
    <span class="text-gray-700 text-2xl font-bold">適格請求書/適格返還請求書 対象一覧</span>
  </div>
  <div class="shadow rounded-lg bg-gray-50 border-1 p-2">
    <div class="flex flex-col">
      <div class="flex-auto mb-8 justify-content-start items-center">
        <span>適格請求書/適格返還請求書を参照するには、下記一覧より「表示」を押してください。</span>
      </div>
      <div class="flex-auto justify-content-start items-center">
        <div class="shadow overflow-auto border-gray-200">
          <table class="min-w-full border-collapse border border-gray-800">
            <thead class="bg-gray-100">
              <tr>
                <th class="w-2/5" colspan="2">料金内訳</th>
                <th class="w-1/5">金額</th>
                <th class="w-1/5">税額</th>
                <th class="w-1/5" />
              </tr>
            </thead>
            <tbody class="divide-y divide-gray-200">
              <!-- 対象年月の一覧を取得して全て表示-->
              {#each detailAggregations as detail}
                <tr>
                  <td>{detail.serviceName}</td>
                  <td>{displayDateYm(detail.useym)}</td>
                  <td>
                    <span class="tabular-nums">
                      {detail.amount.toLocaleString('ja-JP')}円
                    </span>
                  </td>
                  <td>
                    <span class="tabular-nums">
                      {detail.tax.toLocaleString('ja-JP')}円
                    </span>
                  </td>
                  <td>
                    <!-- svelte-ignore a11y-click-events-have-key-events -->
                    <!-- svelte-ignore a11y-no-static-element-interactions -->
                    <span class="link" on:click={() => handleShowDetail(detail)}>表示</span>
                  </td>
                </tr>
              {/each}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
{:else}
  <div class="mb-5 screen-title">
    <span class="text-gray-700 text-2xl font-bold">{detailTitle}</span>
  </div>
  <div class="shadow rounded-lg bg-gray-50 border-1 p-4">
    <div class="text-right">
      <p>株式会社U-NEXT</p>
      <p>登録番号：T7011001116975</p>
    </div>
    <div class="m-4">{$loginUser.sei + '　' + $loginUser.mei + '　'}様</div>

    <div class="flex flex-col justify-items-center items-center mt-2">
      <div class="w-full content-center p-2">
        <div class="inline-grid grid-cols-3 items-center min-w-full p-2">
          <div class="grid-1 justify-self-start w-full">
            <span class="label-title">日付</span>
          </div>
          <div class="grid-1 col-span-2 justify-self-start w-full">
            <p class="label-value">{displayDateYmd(selectedDetail.billYm)}</p>
          </div>
        </div>

        <div class="inline-grid grid-cols-3 items-center min-w-full p-2">
          <div class="grid-1 justify-self-start w-full">
            <span class="label-title">品名</span>
          </div>
          <div class="grid-1 col-span-2 justify-self-start w-full">
            <p class="label-value">
              {selectedDetail.serviceName}　/　{displayDateYm(selectedDetail.useym)}
            </p>
          </div>
        </div>

        <div class="inline-grid grid-cols-3 items-center min-w-full p-2">
          <div class="grid-1 justify-self-start w-full">
            <span class="label-title">金額(税込)</span>
          </div>
          <div class="grid-1 col-span-2 justify-self-start w-full">
            <p class="label-value tabular-nums">
              {selectedDetail.amount.toLocaleString('ja-JP')}円
            </p>
          </div>
        </div>

        <div class="inline-grid grid-cols-3 items-center min-w-full p-2">
          <div class="grid-1 justify-self-start w-full">
            <span class="label-title">消費税</span>
          </div>
          <div class="grid-1 col-span-2 justify-self-start w-full">
            <p class="label-value tabular-nums">
              {selectedDetail.tax.toLocaleString('ja-JP')}円
            </p>
          </div>
        </div>

        <div class="inline-grid grid-cols-3 items-center min-w-full p-2">
          <div class="grid-1 justify-self-start w-full">
            <span class="label-title">税率</span>
          </div>
          <div class="grid-1 col-span-2 justify-self-start w-full">
            <p class="label-value tabular-nums">{selectedDetail.taxRate}%</p>
          </div>
        </div>
      </div>
    </div>
    <div class="flex flex-col justify-items-center items-center">
      <div class="flex-1 m-2">
        <button on:click={handleShowTop} class="button-primary">戻る</button>
      </div>
    </div>
  </div>
{/if}

<style lang="postcss">
  thead tr th {
    @apply bg-gray-100 border border-gray-800 px-3 py-2 text-center text-sm text-gray-700 whitespace-nowrap leading-4;
  }
  tbody tr td {
    @apply border border-gray-800 px-3 py-2 text-center text-sm text-gray-700 leading-4;
  }
  .link {
    @apply underline cursor-pointer;
  }
  .label-title {
    @apply text-sm font-semibold text-gray-700;
  }
  .label-value {
    @apply text-sm text-gray-900 break-all;
  }
  .screen-title {
    @apply text-left;
  }
  .button-primary {
    @apply bg-green-400 rounded-lg hover:bg-green-500 focus:outline-none text-sm font-semibold text-white px-5 py-2;
  }
  @media screen and (max-width: 640px) {
    .screen-title {
      @apply text-center mt-7;
    }
  }
  @media screen and (max-width: 640px) {
    table tr th,
    td {
      @apply px-2 py-1;
    }
  }
</style>
